import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/index'
import Product from '../components/products'
import ProductItem from '../components/product'
import contactus from '../components/contactus'
import aboutus from '../components/aboutus'
import recruit from '../components/recruit'
import shipping from '../components/shipping'
import warehouse from '../components/warehouse'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/product/:id',
      name: 'product',
      component: Product
    },
    {
      path: '/product-item/:name',
      name: 'productItem',
      component: ProductItem
    },
    {
      path: '/contactus',
      name: 'contactus',
      component: contactus
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      component: aboutus
    },

    {
      path: '/recruit',
      name: 'recruit',
      component: recruit
    },
    {
      path: '/shipping',
      name: 'shipping',
      component: shipping
    },
    {
      path: '/warehouse',
      name: 'warehouse',
      component: warehouse
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js